export enum MicrositeBackgroundStyle {
  FLAT = 'FLAT',
  GRADIENT_UP = 'GRADIENT_UP',
  GRADIENT_DOWN = 'GRADIENT_DOWN',
}
